import React from 'react';
import moment from 'moment';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ReactSelect from '../../../components/Select/ReactSelect';

import withStyles from "@material-ui/core/styles/withStyles";
import { FormControlLabel, Checkbox } from '@material-ui/core';
import Check from "@material-ui/icons/Check";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import ScheduleManager from '../ScheduleManager';
import AdvancedScheduleManager from './AdvancedScheduleManager';
import Success from '../../../components/Typography/Success';
import { OrdinalSuffixOf } from '../../../helpers';

class BasicSchedulingObject {
    isNewSchedule = false;
    schedule = null;
    time = moment().format('HH:mm');
    run_daily = false;
    run_on_the_first = false;
    run_end_of_month = false;
    useAdvanced = false;
}

const DayOfWeek = (day) => {
    switch (day) {
        case "1":
            return "Monday";
        case "2":
            return "Tuesday";
        case "3":
            return "Wednesday";
        case "4":
            return "Thursday";
        case "5":
            return "Friday";
        case "6":
            return "Saturday";
        case "7":
            return "Sunday";
    }
}

const styles = {
    label: {
        color: '#777'
    }
}

class Scheduling extends React.Component {
    state = new BasicSchedulingObject();

    componentDidMount() {

        console.log(this.props.report);

        if (this.props.report && this.props.report.schedule)
            this.setState({ schedule: { label: this.props.report.schedule.name, value: this.props.report.schedule_id } });
    }

    renderScheduleDescription() {
        var picked_schedule = this.state.schedule ? this.props.schedules.find(x => x.id === this.state.schedule.value) : null;

        var getText = () => {
            if (!this.state.schedule)
                return "Report will not run on a schedule.";

            var time_based = "";
            var day_based = "";
            var week_based = "";
            var month_based = "";

            if (picked_schedule.time_frequency) {
                var time_periods = picked_schedule.time_frequency.split(":")
                var hours = parseInt(time_periods[0]);
                var minutes = parseInt(time_periods[1]);

                time_based = `every ${hours > 0 ? hours + " hours" : ""}${hours > 0 && minutes > 0 ? " and " : ""}${minutes > 0 ? minutes + " minutes" : ""}`
            }
            if (picked_schedule.daily) {
                day_based = `every${picked_schedule.daily > 1 ? " " + OrdinalSuffixOf(picked_schedule.daily) + " day" : "day"}`;
            }
            if (picked_schedule.weekly) {
                var daysOfWeek = picked_schedule.weekly.split(",");

                week_based = `on ${daysOfWeek.map((x, i, arr) => {
                    if (i < arr.length - 1) {
                        return DayOfWeek(x) + (i === arr.length - 2 ? " " : ", ")
                    } else if (arr.length !== 1) {
                        return "and " + DayOfWeek(x);
                    } else {
                        return DayOfWeek(x);
                    }
                }).join("")} of each week`;
            }
            if (picked_schedule.monthly) {
                var daysOfMonth = picked_schedule.monthly.split(",");

                month_based = `${
                    daysOfMonth.filter(x => x[0] !== "-" && x !== "0").length > 0 ?
                        "on the " +
                        daysOfMonth.filter(x => x[0] !== "-" && x !== "0").map((x, i, arr) => {
                            if (i < arr.length - 1) {
                                return OrdinalSuffixOf(parseInt(x)) + (i === arr.length - 2 ? " " : ", ")
                            } else if (arr.length !== 1) {
                                return "and " + OrdinalSuffixOf(parseInt(x));
                            } else {
                                return OrdinalSuffixOf(parseInt(x));
                            }
                        }).join("") + " of each month"
                        : ""
                    }${
                    daysOfMonth.some(x => x[0] === "-") && daysOfMonth.some(x => x[0] !== "-" && x !== "0") ? " and " : ""
                    }${
                    daysOfMonth.filter(x => x[0] === "-").length ?
                        daysOfMonth.filter(x => x[0] === "-").map((x, i, arr) => {
                            if (i < arr.length - 1) {
                                return x.substring(1) + (i === arr.length - 2 ? " " : ", ")
                            } else if (arr.length !== 1) {
                                return "and " + x.substring(1);
                            } else {
                                return x.substring(1);
                            }
                        }).join("") + " days before the first of each month"
                        : ""
                    }`;
            }

            return `Report will run ${
                (time_based || "") +
                ((time_based && day_based) ? ((week_based && month_based ? ", " : week_based || month_based ? " and " : "") + day_based) : (day_based || "")) +
                (week_based ? (month_based ? (" and " + week_based) : week_based) : "") +
                month_based || ""
                } at ${picked_schedule.runtime.split(":")[0] + ":" + picked_schedule.runtime.split(":")[1]}`;
        }

        if (picked_schedule) {
            return <Success key="description">{getText()}</Success>;
        } else {
            return <Success key="description">Report will not run</Success>;
        }
    }

    getSchedule() {
        if (this.state.isNewSchedule) {
            if (this.state.useAdvanced) {
                return {
                    schedule_id: null,
                    schedule: {
                        ...this.advancedScheduleManager.getSchedule()
                    }
                }
            } else {
                return {
                    schedule_id: null,
                    schedule: {
                        ...this.scheduleManager.getSchedule()
                    }
                }
            }
        } else {
            return {
                schedule_id: (this.state.schedule || {}).value || null,
                schedule: null
            };
        }
    }

    render() {

        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12}>

                    <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    onClick={() => this.setState({ isNewSchedule: !this.state.isNewSchedule })}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                    checked={this.state.isNewSchedule}
                                />
                            }
                            classes={{
                                label: classes.label
                            }}
                            label="Create Schedule?"
                        />
                    </div>

                    {
                        this.state.isNewSchedule ?
                            <div className={classes.checkboxAndRadio}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            tabIndex={-1}
                                            onClick={() => this.setState({ useAdvanced: !this.state.useAdvanced })}
                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                            icon={<Check className={classes.uncheckedIcon} />}
                                            classes={{
                                                checked: classes.checked,
                                                root: classes.checkRoot
                                            }}
                                            checked={this.state.useAdvanced}
                                        />
                                    }
                                    classes={{
                                        label: classes.label
                                    }}
                                    label="Use Advanced Settings?"
                                />
                            </div>
                            :
                            null
                    }

                    {
                        this.state.isNewSchedule ?

                            (
                                !this.state.useAdvanced ?
                                    <ScheduleManager key="main" innerRef={(ref) => this.scheduleManager = ref} report={this.props.report} />
                                    :
                                    <AdvancedScheduleManager key="advanced" ref={(newRef) => this.advancedScheduleManager = newRef} report={this.props.report} />
                            )
                            :
                            [
                                this.renderScheduleDescription(),
                                <ReactSelect
                                    key="pick_schedule"
                                    label="Schedule to Use"
                                    options={
                                        this.props.schedules ?
                                            this.props.schedules.map(x => ({ label: x.name, value: x.id }))
                                            :
                                            [{ label: 'Loading...', value: '' }]
                                    }
                                    placeholder="Schedule"
                                    isSearchable
                                    isClearable

                                    value={this.state.schedule}
                                    onChange={(value) => this.setState({ schedule: value })}
                                />
                            ]
                    }

                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles({ ...regularFormsStyle, ...extendedFormsStyle, ...styles })(Scheduling);